/**
 * * Модель файла для списка файлов в
 */
export default class StartAddFileBatchRequestItem  {
	/**
	 * * Название файла
	 */
	FileName!: string;
	/**
	 * * Размер файла
	 */
	FileSize!: number;
	/**
	 * * Номер файла, если требуется перезаписать существующий
	 */
	FileId?: number;
	constructor(obj?: Partial<StartAddFileBatchRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
